import { ROLES, RoleType } from 'types/roles';

export function extractRoleFromPath(pathname: string): string | undefined {
  // Match paths with language prefix: /nl/invalkracht, /en/school, or /admin
  // Regex breakdown:
  // ^           - Start of string
  // /[a-z]{2}  - Language code (e.g., /en, /nl)
  // /          - Path separator
  // (...)      - Capture group for role
  // (/|$)      - Either a trailing slash or end of string
  const matchWithLang = pathname.match(/^\/[a-z]{2}\/(invalkracht|school|admin)(\/|$)/)?.[1];
  if (matchWithLang) return matchWithLang;

  // Match paths without language prefix: /invalkracht, /school, or /admin
  return pathname.match(/^\/(invalkracht|school|admin)(\/|$)/)?.[1];
}

export async function extractRoleFromParams(
  params: Promise<{ role: string }>, 
  subdomainRole?: RoleType
): Promise<RoleType> {
  try {
    const resolvedParams = await params;
    const role = resolvedParams.role;

    if (role !== ROLES.TEACHER && role !== ROLES.SCHOOL && role !== ROLES.ADMIN) {
      // Default to subdomain role if available, otherwise default to teacher
      return subdomainRole || ROLES.TEACHER;
    }

    return role as RoleType;
  } catch (error) {
    console.error('Failed to resolve params, using subdomain or defaulting to teacher:', error);
    return subdomainRole || ROLES.TEACHER;
  }
}

export function getRedirectUrlForRole(currentPath: string, pathRole: string, userRole: string): string {
  // Handle paths with language prefix (e.g., /nl/invalkracht -> /nl/school)
  const langMatch = currentPath.match(/^\/[a-z]{2}\//);
  if (langMatch) {
    const langPrefix = langMatch[0];
    const pathWithoutLang = currentPath.replace(langPrefix, '/');
    const correctedPath = pathWithoutLang.replace(`/${pathRole}`, `/${userRole}`);
    return `${langPrefix.slice(0, -1)}${correctedPath}`;
  }
  
  // Handle paths without language prefix
  return currentPath.replace(`/${pathRole}`, `/${userRole}`);
}